import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import ImageBackground from '../common/imageBackground';
import NavigationBar from '../common/navigationBar';
import ImageButtonList from '../common/imageButtonList';

class Staycast extends Component {
  /**************
   * Properties *
   **************/
  background = {
    id: 'background',
    src: require('./images/Chromecast.jpeg'),
  };
  navigationBar = {
    mainMenu: false,
    back: false,
    backRoute: '/main_menu',
  };
  buttonList = {
    width: 0,
    height: 0,
  };
  buttons = [
    {
      id: 'staycastEnter',
      to: '/main_menu',
      unhighlight: require('../common/images/empty.png'),
      highlight: require('../common/images/empty.png'),
      alt: '',
    },
  ];

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <div>
        <ImageBackground {...this.background} />
        <ImageButtonList {...this.buttonList} imageButtons={this.buttons} />
        <NavigationBar {...this.navigationBar} />
      </div>
    );
  }
}

export default withRouter(Staycast);
